<template>
    <div>
        <!-- DATOS GENERALES -->
        <v-menu v-if="es_soluciona24 && m1" nav bottom offset-y origin="center center" transition="scale-transition">
            <template v-slot:activator="{ attrs, on }">
                <v-btn text v-on="on" :icon="fullWidth <= 1400" :title="fullWidth < 1400 ? 'Datos Generales' : ''" v-tippy>
                    <v-icon>mdi-folder-information-outline</v-icon>
                    <span class="caption" v-show="fullWidth > 1400">Datos Generales</span>
                </v-btn>
            </template>
            <v-list :tile="false" nav>
                <app-bar-item v-if="valida_permiso('sa24.documentos')" to="/clientes/datos_contribuyente"
                    @click.shift="openNew('/clientes/datos_contribuyente');">
                    <v-icon>mdi-circle-small</v-icon> Información de Empresa
                </app-bar-item>
                <app-bar-item to="/clientes/certificados" v-if="valida_permiso('sa24.sellos')"
                    @click.shift="openNew('/clientes/certificados');">
                    <v-icon>mdi-circle-small</v-icon>
                    <v-list-item-title>Sellos Digitales</v-list-item-title>
                </app-bar-item>
                <app-bar-item to="/cfdi/fiel" v-if="valida_permiso('sa24.sellos')"
                    @click.shift="openNew('/cfdi/fiel');">
                    <v-icon>mdi-circle-small</v-icon>
                    <v-list-item-title>Fiel - Consulta CFDI</v-list-item-title>
                </app-bar-item>
               
                <app-bar-item v-if="valida_permiso('sa24.usuarios')" to="/catalogos/usuariossa24"
                    @click.shift="openNew('/catalogos/usuariossa24');">

                    <v-icon>mdi-circle-small</v-icon>Usuarios

                </app-bar-item>
                <app-bar-item v-if="valida_permiso('sa24.log')" to="/catalogos/acceso_usuarios"
                    @click.shift="openNew('/catalogos/acceso_usuarios');">

                    <v-icon>mdi-circle-small</v-icon>Log de Accesos

                </app-bar-item>
                <app-bar-item v-if="valida_permiso('sa24.monitor')" to="/catalogos/logviews"
                    @click.shift="openNew('/catalogos/logviews');">

                    <v-icon>mdi-circle-small</v-icon>Monitor de Consultas

                </app-bar-item>
               
              
                
            </v-list>
        </v-menu>

        <!-- Catalogos Cliente -->
        <v-menu v-if="es_soluciona24 && m2" bottom nav offset-y origin="center center" transition="scale-transition">
            <template v-slot:activator="{ attrs, on }" >
                <v-btn text v-on="on" :title="fullWidth < 1024 ? 'Catálogos' : ''" :icon="fullWidth <= 1024">
                    <v-icon>list</v-icon>
                    <span class="caption">Catálogos</span>
                </v-btn>
            </template>
            <v-list :tile="false" nav>
                <app-bar-item v-if="valida_permiso('sa24.catalogo.materiales')" to="/sa24/cat_materiales"
                    @click.shift="openNew('/sa24/cat_materiales');">

                    <v-icon>mdi-circle-small</v-icon>Materiales

                </app-bar-item>
                <app-bar-item v-if="valida_permiso('sa24.catalogo.productos')" to="/sa24/cat_productos"
                    @click.shift="openNew('/sa24/cat_productos');">

                    <v-icon>mdi-circle-small</v-icon>Productos

                </app-bar-item>

               

                <app-bar-item v-if="valida_permiso('sa24.catalogo.listamateriales')" to="/sa24/cat_lista_materiales"
                    @click.shift="openNew('/sa24/cat_lista_materiales');">

                    <v-icon>mdi-circle-small</v-icon>Lista Materiales

                </app-bar-item>

                <app-bar-item v-if="valida_permiso('sa24.catalogo.activo.fijo') && false" to="/sa24/cat_activo_fijo"
                    @click.shift="openNew('/sa24/cat_activo_fijo');">

                    <v-icon>mdi-circle-small</v-icon>Activo Fijo

                </app-bar-item>
                <app-bar-item v-if="valida_permiso('catalogos.agentes') " to="/catalogos/emisores_destinatarios" @click.shift="openNew('/catalogos/emisores_destinatarios');">

                    <v-icon>mdi-circle-small</v-icon>Emisores/Destinatarios

                </app-bar-item>
            </v-list>
        </v-menu>

        <v-menu v-if="es_soluciona24 && valida_permiso('sa24.carga')" bottom nav offset-y origin="center center"
            transition="scale-transition">
            <template v-slot:activator="{ attrs, on }">
                <v-btn text v-on="on" :title="fullWidth < 1024 ? 'Carga de Operaciones' : ''" :icon="fullWidth <= 1024">
                    <v-icon>list</v-icon>
                    <span class="caption">Carga de Operaciones</span> 
                </v-btn>
            </template>
            <v-list :tile="false" nav>
                <app-bar-item to="/sa24/entradas" @click.shift="openNew('/sa24/entradas');">
                    <v-icon>mdi-circle-small</v-icon>Importaciones
                </app-bar-item>
        <!--         <app-bar-item to="/sa24/salidas" @click.shift="openNew('/sa24/salidas');">
                    <v-icon>mdi-circle-small</v-icon>Retornos
                </app-bar-item> -->
                <v-menu open-on-hover offset-x nav transition="scale-transition">
                    <template v-slot:activator="{ attrs, on }">
                        <span v-on="on" id="menuRetorno">
                            <app-bar-item>

                                <v-icon>mdi-circle-small</v-icon>Retornos<v-icon>mdi-menu-right</v-icon>

                            </app-bar-item>
                        </span>
                    </template>

                    <v-list :tile="false" nav>
                        <app-bar-item to="/sa24/salidas" @click.native="hideRetorno"
                                @click.shift="openNew('/sa24/salidas');">
                                <v-icon>mdi-circle-small</v-icon>Exportaciones
                            </app-bar-item>
                        <app-bar-item to="/sa24/ctm" @click.native="hideRetorno"
                            @click.shift="openNew('/sa24/ctm');">

                            <v-icon>mdi-circle-small</v-icon>Carga de CTM

                        </app-bar-item>
              
                        <app-bar-item to="/facturastransito" @click.shift="openNew('/facturastransito');">
                            <v-icon>mdi-circle-small</v-icon>Carga de CFDI
                        </app-bar-item>

                        <app-bar-item to="/cfdi/consulta" @click.native="hideRetorno"
                            @click.shift="openNew('/cfdi/consulta');">

                            <v-icon>mdi-circle-small</v-icon>Recuperación CFDI

                        </app-bar-item>
                     
                       
                    </v-list>
                </v-menu>
             <!--    <app-bar-item to="/sa24/ctm" @click.shift="openNew('/sa24/ctm');">
                    <v-icon>mdi-circle-small</v-icon>CTM
                </app-bar-item> -->
                <app-bar-item to="/sa24/descargos" @click.shift="openNew('/sa24/descargos');">
                    <v-icon>mdi-circle-small</v-icon>Descargos
                </app-bar-item>
                <app-bar-item to="/sa24/activo_fijo" @click.shift="openNew('/sa24/activo_fijo');">
                    <v-icon>mdi-circle-small</v-icon>Activo Fijo
                </app-bar-item>
             
                <app-bar-item to="/sa24/saldos" @click.shift="openNew('/sa24/saldos');">
                    <v-icon>mdi-circle-small</v-icon>Saldos
                </app-bar-item>
                
                <app-bar-item to="/sa24/desperdicios" @click.shift="openNew('/sa24/saldos');" v-if="false">
                    <v-icon>mdi-circle-small</v-icon>Desperdicios
                </app-bar-item>

            </v-list>
        </v-menu>



        <!-- Data Stage -->
        <v-menu v-if="es_soluciona24 && m3" bottom nav offset-y origin="center center" transition="scale-transition">
            <template v-slot:activator="{ attrs, on }">
                <v-btn text :icon="fullWidth <= 1400" :title="fullWidth < 1400 ? 'Data Stage' : ''" v-on="on" v-tippy>
                    <v-icon>attach_file</v-icon>
                    <span class="caption" v-show="fullWidth > 1400">Data Stage</span>
                </v-btn>
            </template>
            <v-list :tile="false" nav>
                <app-bar-item v-if="valida_permiso('sa24.datastage.carga')" to="/datastage/cargazip"
                    @click.shift="openNew('/datastage/cargazip');">

                    <v-icon>mdi-circle-small</v-icon>Carga Zip

                </app-bar-item>

                <app-bar-item v-if="valida_permiso('sa24.datastage.bitacora')" to="/datastage/bitacorazip"
                    @click.shift="openNew('/datastage/bitacorazip');">

                    <v-icon>mdi-circle-small</v-icon>Bitácora ZIP

                </app-bar-item>


                <v-divider />
                <app-bar-item @click.native="downloadFile('ManualConsultaDataStage.pdf');">

                    <v-icon>mdi-circle-small</v-icon>Manual Consulta DS

                </app-bar-item>
            </v-list>
        </v-menu>

        <!-- Reportes -->
        <v-menu bottom offset-y origin="center center" nav transition="scale-transition" v-if="es_soluciona24 && m4">
            <template v-slot:activator="{ attrs, on }">
                <v-btn text v-on="on" :icon="fullWidth <= 1400" :title="fullWidth < 1400 ? 'Reportes' : ''" v-tippy>
                    <v-icon>file_copy</v-icon>
                    <span class="caption" v-show="fullWidth > 1400">Reportes</span>
                </v-btn>
            </template>
            <v-list :tile="false" nav>
                <app-bar-item v-if="valida_permiso('sa24.reportes.predeterminados')" to="/predeterminados"
                    @click.shift="openNew('/predeterminados');">
                    <v-icon>mdi-circle-small</v-icon>Predeterminados DS
                </app-bar-item>

                <app-bar-item v-if="valida_permiso('sa24.reportes.predeterminados')" to="/predeterminadosws"
                    @click.shift="openNew('/predeterminadosws');">
                    <v-icon>mdi-circle-small</v-icon>Predeterminados WS
                </app-bar-item>

                <app-bar-item v-if="valida_permiso('sa24reportes.rectificaciones')" to="/rectificaciones"
                    @click.shift="openNew('/rectificaciones');">
                    <v-icon>mdi-circle-small</v-icon>Rectificaciones
                </app-bar-item>

                <app-bar-item v-if="valida_permiso('sa24.reportes.pedimentos')"
                    to="/reportes/consultar_pedimentos_detalle"
                    @click.shift="openNew('/reportes/consultar_pedimentos_detalle');">

                    <v-icon>mdi-circle-small</v-icon>Pedimentos

                </app-bar-item>
                <app-bar-item v-if="valida_permiso('sa24.reportes.soia')" @click.native="hideMenuReportes">

                    <v-icon x-small>mdi-circle-small</v-icon>&nbsp; Consulta Rápida SOIA
                    <v-icon>mdi-menu-right</v-icon>
                </app-bar-item>
                <app-bar-item @click.native="downloadFile('ManualConsultaDataStage.pdf');">

                        <v-icon>mdi-circle-small</v-icon>Manual Consulta DS

                    </app-bar-item>
            </v-list>
        </v-menu>


        <v-menu bottom offset-y origin="center center" nav transition="scale-transition" v-if="es_soluciona24 && valida_permiso('sa24.edrive') ">
                    <template v-slot:activator="{ attrs, on }">
                        <span v-on="on" id="menuRece3">

                            <v-btn text v-on="on" :icon="fullWidth <= 1400" :title="fullWidth < 1400 ? 'eDrive' : ''"
                                v-tippy>
                                <v-icon>file_copy</v-icon>
                                <span class="caption" v-show="fullWidth > 1400">eDrive</span>
                            </v-btn>
                            </span>

                        
                    </template>

                    <v-list :tile="false" nav>
                        <app-bar-item v-if="valida_permiso('sa24.edrive')" to="/edrive/explorer"
                            @click.shift="openNew('/edrive/explorer');">
                            <v-icon>mdi-circle-small</v-icon>Consultar Expediente
                        </app-bar-item>
                        <v-divider />
                        <app-bar-item v-if="valida_permiso('emanifiestoMV.cargazip')" to="/mv_cargazip" @click.shift="openNew('/mv_cargazip');">
                            <v-icon>mdi-circle-small</v-icon>Carga de .Zip archivos M
                        </app-bar-item>

                        <app-bar-item v-if="valida_permiso('emanifiestoMV.bitacora') || valida_permiso('VUCEM.Transmision.ver.edocument')" to="/mv_bitacora" @click.shift="openNew('/mv_bitacora');">
                            <v-icon>mdi-circle-small</v-icon>Bitácora de Archivos M
                        </app-bar-item>

                        <app-bar-item v-if="valida_permiso('emanifiestoMV.reporte.directoM')" to="/manifestacion/directo_archivom" @click.shift="openNew('/manifestacion/directo_archivom');">
                    <v-icon>mdi-circle-small</v-icon>Reporte Directo Archivo M
                </app-bar-item>
           
            </v-list>
        </v-menu>

        <!-- Auditorias -->
        <v-menu bottom offset-y origin="center center" nav transition="scale-transition" v-if="es_soluciona24 && m5">
            <template v-slot:activator="{ attrs, on }">
                <v-btn text v-on="on" id="menuAuditorias" :icon="fullWidth <= 1400"
                    :title="fullWidth < 1400 ? 'Reportes' : ''" v-tippy>
                    <v-icon>mdi-book-search-outline</v-icon>
                    <span class="caption" v-show="fullWidth > 1400">Auditorías</span>
                </v-btn>
            </template>
            <v-list :tile="false" nav>

                <app-bar-item v-if="valida_permiso('sa24.auditoria.faltantes')" to="/sa24/rpt_ped_faltantes" @click.shift="openNew('/sa24/rpt_ped_faltantes');">
                    <v-icon>mdi-circle-small</v-icon>Reporte de pedimentos faltantes por periodo
                </app-bar-item>
                <app-bar-item v-if="valida_permiso('sa24.auditoria.confrontapedimento')" to="" disabled
                    @click.shift="openNew('');">
                    <v-icon>mdi-circle-small</v-icon>Reporte de hallazgos en confronta de valores encabezado pedimento
                </app-bar-item>
                <app-bar-item v-if="valida_permiso('sa24.auditoria.confrontapartida')" to="" disabled
                    @click.shift="openNew('');">
                    <v-icon>mdi-circle-small</v-icon>Reporte de hallazgos en confronta de valores partidas pedimento
                </app-bar-item>
                <v-menu open-on-hover offset-x nav transition="scale-transition">
                    <template v-slot:activator="{ attrs, on }">
                        <span v-on="on" id="menuRetorno">
                            <app-bar-item>

                                <v-icon>mdi-circle-small</v-icon>CTM<v-icon>mdi-menu-right</v-icon>

                            </app-bar-item>
                        </span>
                    </template>

                    <v-list :tile="false" nav>
                       
                        <app-bar-item to="/sa24/memoriactm" @click.native="hideRetorno"
                            @click.shift="openNew('/sa24/memoriactm');">

                            <v-icon>mdi-circle-small</v-icon>Calcular Auditoria CTM

                        </app-bar-item>
                        <app-bar-item to="/sa24/saldo_inicial_ctm" @click.native="hideRetorno"
                            @click.shift="openNew('/sa24/saldo_inicial_ctm');">
                            <v-icon>mdi-circle-small</v-icon>Cargar Saldo Inicial
                        </app-bar-item>
                        <v-divider />
                        <app-bar-item to="/sa24/rpt_ctm_eficiencia_ligue" @click.native="hideRetorno"
                            @click.shift="openNew('/sa24/rpt_ctm_eficiencia_ligue');">
                            <v-icon>mdi-circle-small</v-icon>Reporte Eficiencia en Asociación
                        </app-bar-item>
                      
                        <app-bar-item to="/sa24/rpt_ctm_cfdi_valor_detalle" @click.native="hideRetorno"
                            @click.shift="openNew('/sa24/rpt_ctm_cfdi_valor_detalle');">
                            <v-icon>mdi-circle-small</v-icon>Reporte CTM a CFDI detalle de cantidad valor
                        </app-bar-item>
                        <app-bar-item to="/sa24/resumen_cfdi_ctm" @click.native="hideRetorno"
                            @click.shift="openNew('/sa24/resumen_cfdi_ctm');">
                            <v-icon>mdi-circle-small</v-icon>Resumen CFDI a CTM
                        </app-bar-item>
                        <app-bar-item to="/sa24/rpt_cfdi_ligue_ctm" @click.native="hideRetorno" 
                        @click.shift="openNew('/sa24/rpt_cfdi_ligue_ctm');">
                            <v-icon>mdi-circle-small</v-icon> Reporte de CFDI y cantidades asociadas a CTM
                        </app-bar-item>
             
                      
                       
                    </v-list>
                </v-menu>

            </v-list>
        </v-menu>

        <!-- Reportes RECE -->
        <v-menu bottom offset-y origin="center center" nav transition="scale-transition" v-if="es_soluciona24 && m6 && !es_agente">
            <template v-slot:activator="{ attrs, on }">
                <span v-on="on" id="menuRece">

                    <v-btn text v-on="on" :icon="fullWidth <= 1400" :title="fullWidth < 1400 ? 'Reportes RECE' : ''"
                        v-tippy>
                        <v-icon>file_copy</v-icon>
                        <span class="caption" v-show="fullWidth > 1400">Reportes RECE</span>
                    </v-btn>
                </span>
            </template>
            <v-list :tile="false" nav>
                <v-menu open-on-hover offset-x nav transition="scale-transition">
                    <template v-slot:activator="{ attrs, on }">
                        <span v-on="on">
                            <app-bar-item>

                                <v-icon>mdi-circle-small</v-icon>Catálogos<v-icon>mdi-menu-right</v-icon>

                            </app-bar-item>
                        </span>
                    </template>

                    <v-list :tile="false" nav>
                        <app-bar-item to="/clientes/datos_contribuyente" @click.native="hideRece"
                                @click.shift="openNew('/clientes/datos_contribuyente');">
                                <v-icon>mdi-circle-small</v-icon>Datos Generales del Contribuyente
                            </app-bar-item>
                        <app-bar-item to="/sa24/consulta_cat_productos" @click.native="hideRece"
                            @click.shift="openNew('/sa24/consulta_cat_productos');">

                            <v-icon>mdi-circle-small</v-icon>Productos

                        </app-bar-item>

                        <app-bar-item to="/sa24/consulta_cat_materiales" @click.native="hideRece"
                            @click.shift="openNew('/sa24/consulta_cat_materiales');">

                            <v-icon>mdi-circle-small</v-icon>Materiales

                        </app-bar-item>

                       
                    </v-list>
                </v-menu>
                <v-menu open-on-hover offset-x nav transition="scale-transition">
                    <template v-slot:activator="{ attrs, on }">
                        <span v-on="on">
                            <app-bar-item>

                                <v-icon>mdi-circle-small</v-icon>Aduanas<v-icon>mdi-menu-right</v-icon>

                            </app-bar-item>
                        </span>
                    </template>

                    <v-list :tile="false" nav>
                        <app-bar-item to="/sa24/consulta_entradas" @click.native="hideRece"
                            @click.shift="openNew('/sa24/consulta_entradas') ">

                            <v-icon>mdi-circle-small</v-icon>Entrada de Mercancias ITE

                        </app-bar-item>
                        <app-bar-item to="/sa24/consulta_cat_lista_materiales" @click.native="hideRece"
                            @click.shift="openNew('/sa24/consulta_cat_lista_materiales');">

                            <v-icon>mdi-circle-small</v-icon>Materiales Utilizados

                        </app-bar-item>

                        <app-bar-item to="/sa24/consulta_salidas" @click.native="hideRece"
                            @click.shift="openNew('/sa24/consulta_salidas');">

                            <v-icon>mdi-circle-small</v-icon>Salida de Mercancias ITE

                        </app-bar-item>

                        <app-bar-item to="/sa24/consulta_saldos" @click.native="hideRece" v-if="false" 
                            @click.shift="openNew('/sa24/consulta_saldos');">
                            <v-icon>mdi-circle-small</v-icon>Saldos de Mercancia ITE
                        </app-bar-item>
                        <app-bar-item to="/sa24/consulta_descargos" @click.native="hideRece" v-if="false" 
                            @click.shift="openNew('/sa24/consulta_descargos');">
                            <v-icon>mdi-circle-small</v-icon>Salida Descargos
                        </app-bar-item>

                        <app-bar-item to="/sa24/consulta_activo_fijo" @click.native="hideRece"
                            @click.shift="openNew('/sa24/consulta_activo_fijo');">
                            <v-icon>mdi-circle-small</v-icon>Activo Fijo

                        </app-bar-item>
                    </v-list>
                </v-menu>
                <v-menu open-on-hover offset-x nav transition="scale-transition">
                    <template v-slot:activator="{ attrs, on }">
                        <span v-on="on">
                            <app-bar-item>

                                <v-icon>mdi-circle-small</v-icon>Reportes<v-icon>mdi-menu-right</v-icon>

                            </app-bar-item>
                        </span>
                    </template>

                    <v-list :tile="false" nav>
                    <app-bar-item @click.native="hideRece" to="/sa24/rpt_entradas"
                        @click.shift="openNew('/sa24/rpt_entradas');">
                        <v-icon>mdi-circle-small</v-icon>Reporte de Entradas de Mercancia ITE
                    </app-bar-item>

                    <app-bar-item @click.native="hideRece" to="/sa24/rpt_salidas"
                        @click.shift="openNew('/sa24/rpt_salidas');">
                        <v-icon>mdi-circle-small</v-icon>Reporte de Salidas de Mercancia ITE
                    </app-bar-item>
                    <app-bar-item @click.native="hideRece3" to="/sa24/rpt_descargos"
                         @click.shift="openNew('/sa24/rpt_descargos');">
                        <v-icon>mdi-circle-small</v-icon>Reporte de Salida Descargos
                    </app-bar-item>
                    <app-bar-item @click.native="hideRece" to="/sa24/rpt_saldos"
                        @click.shift="openNew('/sa24/rpt_saldos');">
                        <v-icon>mdi-circle-small</v-icon>Reporte de Saldos de Mercancia ITE
                    </app-bar-item>
                    <app-bar-item @click.native="hideRece" to="/sa24/rpt_cat_lista_materiales"
                    @click.shift="openNew('/sa24/rpt_cat_lista_materiales');">
                        <v-icon>mdi-circle-small</v-icon>Reporte de Materiales Utilizados
                    </app-bar-item>
                    
                    

                    
                 
                    <app-bar-item  @click.native="hideRece" to="/sa24/rpt_cat_productos" v-if="false" 
                        @click.shift="openNew('/sa24/rpt_cat_productos');">
                        <v-icon>mdi-circle-small</v-icon>Reporte de Productos
                    </app-bar-item>
                    <app-bar-item  @click.native="hideRece" to="/sa24/rpt_cat_materiales" v-if="false" 
                        @click.shift="openNew('/sa24/rpt_cat_materiales');">
                        <v-icon>mdi-circle-small</v-icon>Reporte de Materiales
                    </app-bar-item>
                
                    </v-list>
                </v-menu>
               
            </v-list>
        </v-menu>
         <!-- Reportes RECE AGENTE -->
       
         <v-menu bottom offset-y origin="center center" nav transition="scale-transition" v-if="es_soluciona24 && m6 && es_agente">
                    <template v-slot:activator="{ attrs, on }">
                        <span v-on="on" id="menuRece1">

                            <v-btn text v-on="on" :icon="fullWidth <= 1400" :title="fullWidth < 1400 ? 'Catálogos' : ''"
                                v-tippy>
                                <v-icon>mdi-table</v-icon>
                                <span class="caption" v-show="fullWidth > 1400">Catálogos</span>
                            </v-btn>
                            </span>
                      
                    </template>

                    <v-list :tile="false" nav>
                        <app-bar-item to="/clientes/datos_contribuyente" @click.native="hideRece1"
                            @click.shift="openNew('/clientes/datos_contribuyente');">

                            <v-icon>mdi-circle-small</v-icon>Datos Generales del Contribuyente

                        </app-bar-item>
                        <app-bar-item to="/sa24/consulta_cat_productos" @click.native="hideRece1"
                            @click.shift="openNew('/sa24/consulta_cat_productos');">

                            <v-icon>mdi-circle-small</v-icon>Productos

                        </app-bar-item>

                        <app-bar-item to="/sa24/consulta_cat_materiales" @click.native="hideRece1"
                            @click.shift="openNew('/sa24/consulta_cat_materiales');">

                            <v-icon>mdi-circle-small</v-icon>Materiales

                        </app-bar-item>

                       
                    </v-list>
                </v-menu>
                <v-menu bottom offset-y origin="center center" nav transition="scale-transition" v-if="es_soluciona24 && m6 && es_agente">
                    <template v-slot:activator="{ attrs, on }">
                        <span v-on="on" id="menuRece2">

                            <v-btn text v-on="on" :icon="fullWidth <= 1400" :title="fullWidth < 1400 ? 'Aduanas' : ''"
                                v-tippy>
                                <v-icon>mdi-web</v-icon>
                                <span class="caption" v-show="fullWidth > 1400">Aduanas</span>
                            </v-btn>
                            </span>
                       
                    </template>

                    <v-list :tile="false" nav>
                        <app-bar-item to="/sa24/consulta_entradas" @click.native="hideRece2"
                            @click.shift="openNew('/sa24/consulta_entradas') ">

                            <v-icon>mdi-circle-small</v-icon>Entrada de Mercancias ITE

                        </app-bar-item>
                        <app-bar-item to="/sa24/consulta_cat_lista_materiales" @click.native="hideRece2"
                            @click.shift="openNew('/sa24/consulta_cat_lista_materiales');">

                            <v-icon>mdi-circle-small</v-icon> Materiales Utilizados

                        </app-bar-item>

                        <app-bar-item to="/sa24/consulta_salidas" @click.native="hideRece2"
                            @click.shift="openNew('/sa24/consulta_salidas');">

                            <v-icon>mdi-circle-small</v-icon>Salida de Mercancias ITE

                        </app-bar-item>

                        <app-bar-item to="/sa24/consulta_saldos" @click.native="hideRece2" v-if="false" 
                            @click.shift="openNew('/sa24/consulta_saldos');">
                            <v-icon>mdi-circle-small</v-icon>Saldos de Mercancia ITE
                        </app-bar-item>
                        <app-bar-item to="/sa24/consulta_descargos" @click.native="hideRece2" v-if="false" 
                            @click.shift="openNew('/sa24/consulta_descargos');">
                            <v-icon>mdi-circle-small</v-icon>Salida Descargos
                        </app-bar-item>

                        <app-bar-item to="/sa24/consulta_activo_fijo" @click.native="hideRece2"
                            @click.shift="openNew('/sa24/consulta_activo_fijo');">
                            <v-icon>mdi-circle-small</v-icon>Activo Fijo
                        </app-bar-item>



                    </v-list>
                </v-menu>
                <v-menu bottom offset-y origin="center center" nav transition="scale-transition" v-if="es_soluciona24 && m6 && es_agente">
                    <template v-slot:activator="{ attrs, on }">
                        <span v-on="on" id="menuRece3">

                            <v-btn text v-on="on" :icon="fullWidth <= 1400" :title="fullWidth < 1400 ? 'Reportes' : ''"
                                v-tippy>
                                <v-icon>file_copy</v-icon>
                                <span class="caption" v-show="fullWidth > 1400">Reportes</span>
                            </v-btn>
                            </span>

                        
                    </template>

                    <v-list :tile="false" nav>
                    <app-bar-item @click.native="hideRece3" to="/sa24/rpt_entradas"
                        @click.shift="openNew('/sa24/rpt_entradas');">
                        <v-icon>mdi-circle-small</v-icon>Reporte de Entradas de Mercancia ITE
                    </app-bar-item>

                    <app-bar-item @click.native="hideRece3" to="/sa24/rpt_salidas"
                        @click.shift="openNew('/sa24/rpt_salidas');">
                        <v-icon>mdi-circle-small</v-icon>Reporte de Salidas de Mercancia ITE
                    </app-bar-item>
                    <app-bar-item @click.native="hideRece3" to="/sa24/rpt_descargos"
                         @click.shift="openNew('/sa24/rpt_descargos');">
                        <v-icon>mdi-circle-small</v-icon>Reporte de Salida Descargos
                    </app-bar-item>
                    <app-bar-item @click.native="hideRece3" to="/sa24/rpt_saldos"
                        @click.shift="openNew('/sa24/rpt_saldos');">
                        <v-icon>mdi-circle-small</v-icon>Reporte de Saldos de Mercancia ITE
                    </app-bar-item>
                    <app-bar-item @click.native="hideRece3" to="/sa24/rpt_cat_lista_materiales"
                    @click.shift="openNew('/sa24/rpt_cat_lista_materiales');">
                       
                        <v-icon>mdi-circle-small</v-icon>Reporte de Materiales Utilizados
                    </app-bar-item>
                                        
         
                    <app-bar-item v-if="false"  @click.native="hideRece3" to="/sa24/rpt_cat_productos"
                        @click.shift="openNew('/sa24/rpt_cat_productos');">
                        <v-icon>mdi-circle-small</v-icon>Reporte de Productos
                    </app-bar-item>
                    <app-bar-item v-if="false"  @click.native="hideRece3" to="/sa24/rpt_cat_materiales"
                        @click.shift="openNew('/sa24/rpt_cat_materiales');">
                        <v-icon>mdi-circle-small</v-icon>Reporte de Materiales
                    </app-bar-item>
           
            </v-list>
        </v-menu>
     
    </div>
</template>

<script>
// Components
import {
    VHover,
    VListItem
} from "vuetify/lib";

// Utilities
import {
    mapState,
    mapMutations
} from "vuex";

import Util from "@/util";
import axios from "axios";

export default {
    name: "menuSa24",

    created() {



    },
    components: {

        AppBarItem: {
            render(h) {
                return h(VHover, {
                    scopedSlots: {
                        default: ({
                            hover
                        }) => {
                            return h(
                                VListItem, {
                                attrs: this.$attrs,
                                class: {
                                    "black--text": !hover,
                                    "white--text secondary elevation-12": hover
                                },
                                props: {
                                    activeClass: "",
                                    dark: hover,
                                    link: true,
                                    ...this.$attrs
                                }
                            },
                                this.$slots.default
                            );
                        }
                    }
                });
            }
        }
    },

    props: {
        value: {
            type: Boolean,
            default: false
        }
    },

    data: () => ({
        fab: false,

        show_loading: false,
        notificationsNumber: 0,
        show: true,
        rfc: "",
        razon: "",
        tipo_usuario: "",
        id_cliente: 0,
        minifiedLeft: false,
        hiddenLeft: false,
        avatar: "undefined",

        notifications: [
            "Mike John Responded to your email",
            "You have 5 new tasks",
            `You're now friends with Andrew`,
            "Another Notification",
            "Another one"
        ]
    }),

    computed: {
        ...mapState(["drawer"]),
        fullWidth() {
            return document.documentElement.clientWidth;
        },
        view_trafico() {
            return this.$store.state.trafico;
        },
        view_costing() {
            return this.$store.state.costing;
        },
        es_agente(){
            return this.$local_storage.get("perfil_grupo") == 66;
        },
        view_emanifiesto() {
            return this.$store.state.emanifiesto;
        },
        view_carta_porte() {
            return this.$store.state.carta_porte;
        },
        view_sa31() {
            return this.$store.state.sa31;
        },
        view_sa24() {
            return this.$store.state.sa24;
        },
        toolbarColor() {
            return this.$vuetify.options.extra.mainNav;
        },
        soloEcosting() {
            return this.$local_storage.get("DATA.STAGE.bitacora") != 100 && this.$local_storage.get("VUCEM.Transmision.nuevo.cove") != 100 && this.$local_storage.get("Reportes.ecosting.consulta.facturas") == 100;
        },
        planta_referencia() {
            return this.$local_storage.get("Modulo16") == 100;
        },
        soloEmanifiesto() {
            return this.$local_storage.get("DATA.STAGE.bitacora") != 100 &&
                this.$local_storage.get("VUCEM.Transmision.nuevo.cove") != 100 &&
                this.$local_storage.get("Reportes.ecosting.consulta.facturas") != 100 &&
                this.$local_storage.get("EmanifiestoCP.bitacora") == 100 &&
                (this.$local_storage.get("EmanifiestoMV.bitacora") == 100) && this.$local_storage.get("Modulo18") != 100;
        },
        es_transportista() {
            return this.$local_storage.get("es_transportista") == 1;
        },
        solo_soluciona() {
            return this.$local_storage.get("DATA.STAGE.bitacora") != 100 && this.$local_storage.get("VUCEM.Transmision.nuevo.cove") != 100 &&
                this.$local_storage.get("Reportes.ecosting.consulta.facturas") != 100 && this.$local_storage.get("EmanifiestoCP.bitacora") != 100 &&
                this.$local_storage.get("EmanifiestoAA.edrive.consultar") != 100 &&
                (this.$local_storage.get("EmanifiestoMV.bitacora") != 100) && this.$local_storage.get("Logistica.nuevoregistro") != 100 &&
                (this.$local_storage.get("Modulo15") == 100 || this.$local_storage.get("Modulo16") == 100) && this.$local_storage.get("Modulo18") != 100;
        },
        solo_soluciona24() {
            return this.$local_storage.get("DATA.STAGE.bitacora") != 100 && this.$local_storage.get("VUCEM.Transmision.nuevo.cove") != 100 &&
                this.$local_storage.get("Reportes.ecosting.consulta.facturas") != 100 && this.$local_storage.get("EmanifiestoCP.bitacora") != 100 &&
                this.$local_storage.get("EmanifiestoAA.edrive.consultar") != 100 &&
                (this.$local_storage.get("EmanifiestoMV.bitacora") != 100) && this.$local_storage.get("Logistica.nuevoregistro") != 100 &&
                this.$local_storage.get("Modulo15") != 100 && this.$local_storage.get("Modulo16") != 100 && this.$local_storage.get("Modulo18") == 100;
        },
        /*     es_soluciona() {
                return
                this.view_sa31 == 1 &&
                    this.view_costing == 0 &&
                    this.view_emanifiesto == 0 &&
                    this.view_carta_porte == 0 &&
                    this.view_trafico == 0 &&
                    this.$local_storage.get("id_cliente") > 0 &&
                    this.$local_storage.get("Modulo14") != 100;
            }, */
        es_soluciona24() {
            return this.solo_soluciona24 || (
                this.view_sa24 == 1 &&
                this.view_sa31 == 0 &&
                this.view_costing == 0 &&
                this.view_emanifiesto == 0 &&
                this.view_carta_porte == 0 &&
                this.view_trafico == 0) && this.$local_storage.get("id_cliente") > 0;
        },

        rfc_transportista() {
            return this.$local_storage.get("rfc_grupo");;
        },
        Admin() {
            return (
                this.$local_storage.get("tipo_usuario") == "Super Usuario" &&
                this.$local_storage.get("id_cliente") == 0
            );
        },
        esSuper() {
            return (
                this.$local_storage.get("tipo_usuario") == "Super Usuario"
            );
        },
        Legal() {
            return (this.$local_storage.get("tipo_usuario") == "Asuntos Legales");
        },
        Pagos() {
            return (this.$local_storage.get("tipo_usuario") == "Pagos");
        },
        soloCartaPorte() {
            return (this.$local_storage.get("soloCartaPorte") == 100);
        },
        m1() {
            return (
                this.$local_storage.get("id_cliente") > 0 &&
                (
                    this.valida_permiso("sa24.documentos") ||
                    this.valida_permiso("sa24.log") ||
                    this.valida_permiso("ssa24.usuarios") ||
                    this.valida_permiso("sa24.monitor")
                )
            );
        },
        m2() {
            return (
                this.$local_storage.get("id_cliente") > 0 &&
                (
                    this.valida_permiso("sa24.catalogo.productos") ||
                    this.valida_permiso("sa24.catalogo.materiales") ||
                    this.valida_permiso("sa24.catalogo.listamateriales") ||
                    this.valida_permiso("sa24.catalogo.activo.fijo")

                )
            );
        },
        m3() {
            return (
                this.$local_storage.get("id_cliente") > 0 &&
                (
                    this.valida_permiso("sa24.datastage.carga") ||
                    this.valida_permiso("sa24.datastage.bitacora") ||
                    this.valida_permiso("sa24.datastage.directos")

                )
            );
        },
        m4() {
            return (
                this.$local_storage.get("id_cliente") > 0 &&
                (
                    this.valida_permiso("sa24.reportes.predeterminados") ||
                    this.valida_permiso("sa24reportes.rectificaciones") ||
                    this.valida_permiso("sa24.reportes.pedimentos") ||
                    this.valida_permiso("sa24.reportes.soia") 

                )
            );
        },
        m5() {
            return (
                this.$local_storage.get("id_cliente") > 0 &&
                (
                    this.valida_permiso("sa24.auditoria.faltantes") ||
                    this.valida_permiso("sa24.auditoria.confrontapedimento") ||
                    this.valida_permiso("sa24.auditoria.confrontapartida")

                )
            );
        },
        m6() {
            return (
                this.$local_storage.get("id_cliente") > 0 &&
                (
                    this.valida_permiso("sa24.rece")

                )
            );
        },

        is_consignatario() {
            return this.$local_storage.get("perfil_grupo") == 43;
        },

        is_cliente() {
            return (
                this.$local_storage.get("id_cliente") > 0
            );
        },
        is_cliente_bosch() {
            return (
                this.$local_storage.get("id_cliente") > 0 && this.$local_storage.get("rfc") == "RBS980129FQ5"
            );
        },

        esGrupo() {
            return this.$local_storage.get("panel_grupo") == 1 && this.$local_storage.get('grupo') > 0 && this.$local_storage.get("tipo_usuario") == "Grupo" && this.$local_storage.get("id_cliente") == 0;
        },

    },

    methods: {
        ...mapMutations({
            setDrawer: "SET_DRAWER"
        }),
        valida_permiso(permiso) {
            return (
                this.$local_storage.get(permiso) == 100 && this.$local_storage.get("id_cliente") > 0
            );
        },
        valida_permiso_t(permiso) {
            return (
                this.$local_storage.get(permiso) == 100
            );
        },
        linkConsultaRapida: function () {

            //   window.open("https://aplicacionesc.mat.sat.gob.mx/SOIANET/oia_consultarap_cep.aspx", "_blank");
            window.open("https://aplicacionesc.mat.sat.gob.mx/SOIA_CR_WEB/oia_consultarap_cep.aspx", "_blank");

        },
        linkConsultaA24: function () {
            let email = this.$local_storage.get("email");
            let link = "https://integra24.mx/A24/ReportesA24U?USU=" + email;
            window.open(link, "_blank");
        },

        openNew: function (h) {
            window.open(h, "_blank");
        },

        base64ToArrayBuffer: function (base64) {
            var binaryString = window.atob(base64);
            var binaryLen = binaryString.length;
            var bytes = new Uint8Array(binaryLen);
            for (var i = 0; i < binaryLen; i++) {
                var ascii = binaryString.charCodeAt(i);
                bytes[i] = ascii;
            }
            return bytes;
        },
        downloadFile: function (key) {
            this.$root.$dialogLoader.show('Espere un momento por favor..');
            var datos = {
                id: key,
                bucket: "descargas.econnectpro.mx"
            }
            let nombre_download = key.split("/").pop();
            axios.post(this.$hostname + "s3/download/", datos, {
                "Content-type": "application/json",
                "Access-Control-Allow-Origin": "*",
                Allow: "POST",
                "cache-control": "no-cache",
            })
                .then(response => {
                    var bytes = this.base64ToArrayBuffer(response.data);
                    let blob = new Blob([bytes], {
                        type: response.headers["content-type"]
                    }),
                        url = window.URL.createObjectURL(blob);

                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    a.href = url;
                    a.download = nombre_download;
                    a.click();
                    a.parentNode.removeChild(a);
                })
                .catch(error => {
                    console.log(error);

                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });

        },
        hideMenuReportes: function () {

            var menu1 = document.getElementById("menuNuevoInforme");

            var menu2 = document.getElementById("menuVucem");
            var menu3 = document.getElementById("menuCargos");
            var menu4 = document.getElementById("menuAbonos");
            var menu5 = document.getElementById("menuNuevoInforme");

            if (menu1) {
                menu1.click();
            }

            if (menu2) {
                menu2.click();
            }

            if (menu3) {
                menu3.click();
            }
            if (menu4) {
                menu4.click();
            }
            if (menu5) {
                menu5.click();
            }

        },
        hideRece: function () {

            var menu1 = document.getElementById("menuRece");
            if (menu1) {
                menu1.click();
            }
        },
        hideRetorno: function () {

            var menu1 = document.getElementById("menuRetorno");
            if (menu1) {
                menu1.click();
            }
            },
        hideRece1: function () {

                var menu1 = document.getElementById("menuRece1");
                if (menu1) {
                    menu1.click();
                }
                },
                hideRece2: function () {

                var menu1 = document.getElementById("menuRece2");
                if (menu1) {
                    menu1.click();
                }
                },
                hideRece3: function () {

                var menu1 = document.getElementById("menuRece3");
                if (menu1) {
                    menu1.click();
                }
                },
    },

};
</script>

<style scoped>
.v-menu__content .v-list--nav .v-list-item {
    padding-top: 0px;
    padding-bottom: 0px;
    padding-left: 5px;
    text-decoration: none;
}

.v-sheet button.v-btn.v-size--default:not(.v-btn--icon):not(.v-btn--fab) {
    padding-left: 10px !important;
}
</style>
